module.exports = __webpack_public_path__ + "03_mustache_grey.364e7271.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/male/layer3/03_mustache_grey.png
// module id = QY9H
// module chunks = 0